/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useInstallPrompt } from '@/lib/pwa/useInstallPrompt';

export function InstallButton() {
  const { canInstall, isIos, installed, promptInstall } = useInstallPrompt();
  const { t } = useTranslation('core');
  const [dismissed, setDismissed] = useState(false);

  if (installed || dismissed) return null;
  // iOS has no beforeinstallprompt; only show the manual hint when not already installed (standalone).
  const iosStandalone = (navigator as unknown as { standalone?: boolean }).standalone === true;
  const showIosHint = isIos && !iosStandalone;
  if (!canInstall && !showIosHint) return null;

  return (
    <div className="pwa-install" role="alert" aria-label={t('pwa.install')}>
      {showIosHint ? (
        <span className="pwa-install-hint">{t('pwa.installHintIos')}</span>
      ) : (
        <button className="pwa-install-btn" onClick={promptInstall}>{t('pwa.install')}</button>
      )}
      <button className="pwa-install-x" aria-label={t('pwa.dismiss')} onClick={() => setDismissed(true)}>×</button>
      <style>{`
        .pwa-install {
          position: fixed; left: 1rem; bottom: 1rem; z-index: 1001;
          display: flex; align-items: center; gap: 0.5rem;
          padding: 0.6rem 0.75rem;
          background: var(--color-bg-secondary);
          border: 1px solid var(--color-border-subtle);
          border-radius: var(--radius-lg); box-shadow: var(--shadow-md);
          color: var(--color-text-primary); font-family: var(--font-body); font-size: 0.85rem;
        }
        .pwa-install-btn {
          padding: 0.35rem 0.75rem; border: none; border-radius: var(--radius-md);
          background: var(--color-brand-primary); color: #fff; cursor: pointer;
        }
        .pwa-install-btn:hover { background: var(--color-brand-primary-hover); }
        .pwa-install-hint { max-width: 240px; color: var(--color-text-secondary); }
        .pwa-install-x {
          border: none; background: transparent; cursor: pointer;
          color: var(--color-text-muted); font-size: 1.1rem; line-height: 1;
        }
      `}</style>
    </div>
  );
}
